/* PoppySeed Homepage JS — upload to Assets folder */
document.addEventListener('DOMContentLoaded', function () {

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.ps-section-hero, .ps-section-hero + *, section');
  reveals.forEach(function(el) {
    el.classList.add('ps-reveal');
  });
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ps-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.ps-reveal').forEach(function(el) { io.observe(el); });

  /* Marquee speed from section setting */
  var marquee = document.querySelector('.ps-marquee__track');
  if (marquee) {
    var speed = marquee.closest('.ps-marquee') ? marquee.closest('.ps-marquee').dataset.speed : 30;
    marquee.style.animationDuration = (speed || 30) + 's';
  }

  /* Product card stagger */
  document.querySelectorAll('.ps-product-card').forEach(function(card, i) {
    card.style.transitionDelay = (i * 80) + 'ms';
  });

});
